import * as React from 'react';
import styled from 'styled-components';
import { ITsaResult } from '../../../data/providers/reports/tsaReportProvider';
import { Entity } from '../../../data/types';
import { Row } from '../../layout/Row';
import { ListAvatar } from '../../shared/List/ListAvatar';
import { Metric } from '../../shared/Metric';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { DataCell, DataColumn } from '../utils/Table';

interface IProps {
  result: ITsaResult;
  pdfMode: EPdfMode;
  entity: Entity;
  color: string;
  rank: number;
  shape: number[];
}

export const TsaResult = (props: IProps): React.ReactElement => {
  return (
    <Row
      className='avoid-break'
      style={{
        height: '100%',
      }}
    >
      <DataColumn style={{ flex: props.shape[0] }}>
        <DataCell>
          <Rank>{`${props.rank}.`}</Rank>
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[1], minWidth: 0 }}>
        <DataCell style={{ flex: 1, padding: '0px' }}>
          <ListAvatar
            entity={props.result.entity}
            inverse={shouldInvert(props.pdfMode)}
            pdf={isPdf(props.pdfMode)}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[2] }}>
        <DataCell>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.tsa}
            units={''}
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[3] }}>
        <DataCell>
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.quartile}
            units={''}
          />
        </DataCell>
      </DataColumn>
    </Row>
  );
};

const Rank = styled.div`
  margin-right: 5px;
  font-size: 1.1em;
`;
